import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, AbstractControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackbarMessageComponent } from 'src/app/components/snackbar-message/snackbar-message.component';
import { LoadingService } from 'src/app/services/loading.service';
import { UserService } from 'src/app/services/user.service';
import { fade, fadeOp } from 'src/app/util/animations.util';
import { checkPasswords } from 'src/app/util/check-passwords.util';
import { strongPassword } from 'src/app/util/regex';

@Component({
  selector: 'app-reset-password-home',
  templateUrl: './reset-password-home.component.html',
  styleUrls: [
    '../../../sign-in/components/sign-in/sign-in.component.css',
    './reset-password-home.component.css'
  ],
  animations: [
    fade,
    fadeOp
  ]
})
export class ResetPasswordHomeComponent implements OnInit {
  resetForm: FormGroup;
  private token: string;
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private user: UserService,
    private snackbar: MatSnackBar,
    private _loadingService: LoadingService
  ) { }

  ngOnInit(): void {
    this.resetForm = this.fb.group({
      password: ["", [Validators.required, Validators.pattern(strongPassword)]],
      confirmPassword: ["", [Validators.required, Validators.pattern(strongPassword)]]
    }, {
      validators: [checkPasswords]
    });
    this.init();
  }
  
  init(): void {
    this.route.params.subscribe((params) => {
      if (!params.token)  return this.router.navigateByUrl("/login");
      this.token = params.token;
    });
  }

  onSubmit(): void {
    if (this.resetForm.invalid) return this.resetForm.markAllAsTouched();
    const password = this.resetForm.value;
    const payload = {
      password: password.password,
      confirm_password: password.confirmPassword,
      reset_password_token: this.token
    }
    this._loadingService._setLoading();
    this.user.resetPassword(payload)
    .then((response) => {
      this._loadingService._clearLoading();
      this.snackbar.openFromComponent(SnackbarMessageComponent, {
        duration: 1500,
        data: {
          message: "MSG.RE_PASSWORD_SUCCESS"
        },
        panelClass: 'bg-accent'
      });
      setTimeout(() => {
        this.router.navigateByUrl("/auth/login")
      }, 1000)
    })
    .catch((response) => {
      if (response.message == "Unauthorized")
        this.resetForm.setErrors({
          token: true
        });
    })
  }
  
  get password(): AbstractControl {
    return this.resetForm.get("password");
  }
  get confirmPassword(): AbstractControl {
    return this.resetForm.get("confirmPassword");
  }
}
